const CDN_URL = "https://cdn.tagg.live/emotion-design/images";
export const cdnImages = {
  galleryCarousel: {
    "1": {
      sm: `${CDN_URL}/gallery-carousel/1-sm.webp`,
      md: `${CDN_URL}/gallery-carousel/1-md.webp`,
      lg: `${CDN_URL}/gallery-carousel/1-lg.webp`,
      xl: `${CDN_URL}/gallery-carousel/1-xl.webp`,
      original: `${CDN_URL}/gallery-carousel/1-original.webp`,
    },
    "2": {
      sm: `${CDN_URL}/gallery-carousel/2-sm.webp`,
      md: `${CDN_URL}/gallery-carousel/2-md.webp`,
      lg: `${CDN_URL}/gallery-carousel/2-lg.webp`,
      xl: `${CDN_URL}/gallery-carousel/2-xl.webp`,
      original: `${CDN_URL}/gallery-carousel/2-original.webp`,
    },
    "3": {
      sm: `${CDN_URL}/gallery-carousel/3-sm.webp`,
      md: `${CDN_URL}/gallery-carousel/3-md.webp`,
      lg: `${CDN_URL}/gallery-carousel/3-lg.webp`,
      xl: `${CDN_URL}/gallery-carousel/3-xl.webp`,
      original: `${CDN_URL}/gallery-carousel/3-original.webp`,
    },
    "4": {
      sm: `${CDN_URL}/gallery-carousel/4-sm.webp`,
      md: `${CDN_URL}/gallery-carousel/4-md.webp`,
      lg: `${CDN_URL}/gallery-carousel/4-lg.webp`,
      xl: `${CDN_URL}/gallery-carousel/4-xl.webp`,
      original: `${CDN_URL}/gallery-carousel/4-original.webp`,
    },
    "5": {
      sm: `${CDN_URL}/gallery-carousel/5-sm.webp`,
      md: `${CDN_URL}/gallery-carousel/5-md.webp`,
      lg: `${CDN_URL}/gallery-carousel/5-lg.webp`,
      xl: `${CDN_URL}/gallery-carousel/5-xl.webp`,
      original: `${CDN_URL}/gallery-carousel/5-original.webp`,
    },
    "6": {
      sm: `${CDN_URL}/gallery-carousel/6-sm.webp`,
      md: `${CDN_URL}/gallery-carousel/6-md.webp`,
      lg: `${CDN_URL}/gallery-carousel/6-lg.webp`,
      xl: `${CDN_URL}/gallery-carousel/6-xl.webp`,
      original: `${CDN_URL}/gallery-carousel/6-original.webp`,
    },
    "7": {
      sm: `${CDN_URL}/gallery-carousel/7-sm.webp`,
      md: `${CDN_URL}/gallery-carousel/7-md.webp`,
      lg: `${CDN_URL}/gallery-carousel/7-lg.webp`,
      xl: `${CDN_URL}/gallery-carousel/7-xl.webp`,
      original: `${CDN_URL}/gallery-carousel/7-original.webp`,
    },
    "8": {
      sm: `${CDN_URL}/gallery-carousel/8-sm.webp`,
      md: `${CDN_URL}/gallery-carousel/8-md.webp`,
      lg: `${CDN_URL}/gallery-carousel/8-lg.webp`,
      xl: `${CDN_URL}/gallery-carousel/8-xl.webp`,
      original: `${CDN_URL}/gallery-carousel/8-original.webp`,
    },
    "9": {
      sm: `${CDN_URL}/gallery-carousel/9-sm.webp`,
      md: `${CDN_URL}/gallery-carousel/9-md.webp`,
      lg: `${CDN_URL}/gallery-carousel/9-lg.webp`,
      xl: `${CDN_URL}/gallery-carousel/9-xl.webp`,
      original: `${CDN_URL}/gallery-carousel/9-original.webp`,
    },
    "10": {
      sm: `${CDN_URL}/gallery-carousel/10-sm.webp`,
      md: `${CDN_URL}/gallery-carousel/10-md.webp`,
      lg: `${CDN_URL}/gallery-carousel/10-lg.webp`,
      xl: `${CDN_URL}/gallery-carousel/10-xl.webp`,
      original: `${CDN_URL}/gallery-carousel/10-original.webp`,
    },
  },
  heroBg: {
    "1": `${CDN_URL}/hero-bgs-updated/1.webp`,
    "2": `${CDN_URL}/hero-bgs-updated/2.webp`,
    "3": `${CDN_URL}/hero-bgs-updated/3.webp`,
    "4": `${CDN_URL}/hero-bgs-updated/4.webp`,
    "5": `${CDN_URL}/hero-bgs-updated/5.webp`,
    "6": `${CDN_URL}/hero-bgs-updated/6.webp`,
    "7": `${CDN_URL}/hero-bgs-updated/7.webp`,
    "8": `${CDN_URL}/hero-bgs-updated/8.webp`,
    "9": `${CDN_URL}/hero-bgs-updated/9.webp`,
    "10": `${CDN_URL}/hero-bgs-updated/10.webp`,
  },
  heroBgMobile: {
    "1": `${CDN_URL}/mobile-hero-bgs/1.webp`,
    "2": `${CDN_URL}/mobile-hero-bgs/2.webp`,
    "3": `${CDN_URL}/mobile-hero-bgs/3.webp`,
    "4": `${CDN_URL}/mobile-hero-bgs/4.webp`,
    "5": `${CDN_URL}/mobile-hero-bgs/5.webp`,
    "6": `${CDN_URL}/mobile-hero-bgs/6.webp`,
    "7": `${CDN_URL}/mobile-hero-bgs/7.webp`,
    "8": `${CDN_URL}/mobile-hero-bgs/8.webp`,
    "9": `${CDN_URL}/mobile-hero-bgs/9.webp`,
    "10": `${CDN_URL}/mobile-hero-bgs/10.webp`,
  },
  taglineImages: {
    curve: `${CDN_URL}/tagline-images/tagline-curve.webp`,
    spike: `${CDN_URL}/tagline-images/tagline-spike.webp`,
    bullet: `${CDN_URL}/tagline-images/tagline-bullet.webp`,
  },
  logos: {
    company1: `${CDN_URL}/logos/client1.svg`,
    company2: `${CDN_URL}/logos/client2.svg`,
    company3: `${CDN_URL}/logos/client3.svg`,
    company4: `${CDN_URL}/logos/client4.svg`,
    company5: `${CDN_URL}/logos/client5.svg`,
    company6: `${CDN_URL}/logos/client6.svg`,
    logo: `${CDN_URL}/logos/logo.svg`,
    menu: `${CDN_URL}/logos/menu.svg`,
  },
  projectsMedia: {
    project01: {
      cover: {
        lg: `${CDN_URL}/projects-media/project-01/cover-lg.webp`,
        md: `${CDN_URL}/projects-media/project-01/cover-md.webp`,
        original: `${CDN_URL}/projects-media/project-01/cover-original.webp`,
        sm: `${CDN_URL}/projects-media/project-01/cover-sm.webp`,
        xl: `${CDN_URL}/projects-media/project-01/cover-xl.webp`,
      },
      thumbnail1: {
        lg: `${CDN_URL}/projects-media/project-01/thumbnail-1-lg.webp`,
        md: `${CDN_URL}/projects-media/project-01/thumbnail-1-md.webp`,
        original: `${CDN_URL}/projects-media/project-01/thumbnail-1-original.webp`,
        sm: `${CDN_URL}/projects-media/project-01/thumbnail-1-sm.webp`,
        xl: `${CDN_URL}/projects-media/project-01/thumbnail-1-xl.webp`,
      },
      thumbnail2: {
        lg: `${CDN_URL}/projects-media/project-01/thumbnail-2-lg.webp`,
        md: `${CDN_URL}/projects-media/project-01/thumbnail-2-md.webp`,
        original: `${CDN_URL}/projects-media/project-01/thumbnail-2-original.webp`,
        sm: `${CDN_URL}/projects-media/project-01/thumbnail-2-sm.webp`,
        xl: `${CDN_URL}/projects-media/project-01/thumbnail-2-xl.webp`,
      },
    },
    project02: {
      thumbnail1: {
        lg: `${CDN_URL}/projects-media/project-02/thumbnail-1-lg.webp`,
        md: `${CDN_URL}/projects-media/project-02/thumbnail-1-md.webp`,
        original: `${CDN_URL}/projects-media/project-02/thumbnail-1-original.webp`,
        sm: `${CDN_URL}/projects-media/project-02/thumbnail-1-sm.webp`,
        xl: `${CDN_URL}/projects-media/project-02/thumbnail-1-xl.webp`,
      },
      thumbnail2: {
        lg: `${CDN_URL}/projects-media/project-02/thumbnail-2-lg.webp`,
        md: `${CDN_URL}/projects-media/project-02/thumbnail-2-md.webp`,
        original: `${CDN_URL}/projects-media/project-02/thumbnail-2-original.webp`,
        sm: `${CDN_URL}/projects-media/project-02/thumbnail-2-sm.webp`,
        xl: `${CDN_URL}/projects-media/project-02/thumbnail-2-xl.webp`,
      },
    },
    project03: {
      cover: {
        lg: `${CDN_URL}/projects-media/project-03/cover-lg.webp`,
        md: `${CDN_URL}/projects-media/project-03/cover-md.webp`,
        original: `${CDN_URL}/projects-media/project-03/cover-original.webp`,
        sm: `${CDN_URL}/projects-media/project-03/cover-sm.webp`,
        xl: `${CDN_URL}/projects-media/project-03/cover-xl.webp`,
      },
      thumbnail1: {
        lg: `${CDN_URL}/projects-media/project-03/thumbnail-1-lg.webp`,
        md: `${CDN_URL}/projects-media/project-03/thumbnail-1-md.webp`,
        original: `${CDN_URL}/projects-media/project-03/thumbnail-1-original.webp`,
        sm: `${CDN_URL}/projects-media/project-03/thumbnail-1-sm.webp`,
        xl: `${CDN_URL}/projects-media/project-03/thumbnail-1-xl.webp`,
      },
      thumbnail2: {
        lg: `${CDN_URL}/projects-media/project-03/thumbnail-2-lg.webp`,
        md: `${CDN_URL}/projects-media/project-03/thumbnail-2-md.webp`,
        original: `${CDN_URL}/projects-media/project-03/thumbnail-2-original.webp`,
        sm: `${CDN_URL}/projects-media/project-03/thumbnail-2-sm.webp`,
        xl: `${CDN_URL}/projects-media/project-03/thumbnail-2-xl.webp`,
      },
    },
    project04: {
      cover: {
        lg: `${CDN_URL}/projects-media/project-04/cover-lg.webp`,
        md: `${CDN_URL}/projects-media/project-04/cover-md.webp`,
        original: `${CDN_URL}/projects-media/project-04/cover-original.webp`,
        sm: `${CDN_URL}/projects-media/project-04/cover-sm.webp`,
        xl: `${CDN_URL}/projects-media/project-04/cover-xl.webp`,
      },
      thumbnail1: {
        lg: `${CDN_URL}/projects-media/project-04/thumbnail-1-lg.webp`,
        md: `${CDN_URL}/projects-media/project-04/thumbnail-1-md.webp`,
        original: `${CDN_URL}/projects-media/project-04/thumbnail-1-original.webp`,
        sm: `${CDN_URL}/projects-media/project-04/thumbnail-1-sm.webp`,
        xl: `${CDN_URL}/projects-media/project-04/thumbnail-1-xl.webp`,
      },
      thumbnail2: {
        lg: `${CDN_URL}/projects-media/project-04/thumbnail-2-lg.webp`,
        md: `${CDN_URL}/projects-media/project-04/thumbnail-2-md.webp`,
        original: `${CDN_URL}/projects-media/project-04/thumbnail-2-original.webp`,
        sm: `${CDN_URL}/projects-media/project-04/thumbnail-2-sm.webp`,
        xl: `${CDN_URL}/projects-media/project-04/thumbnail-2-xl.webp`,
      },
    },
    project05: {
      thumbnail1: {
        lg: `${CDN_URL}/projects-media/project-05/thumbnail-1-lg.webp`,
        md: `${CDN_URL}/projects-media/project-05/thumbnail-1-md.webp`,
        original: `${CDN_URL}/projects-media/project-05/thumbnail-1-original.webp`,
        sm: `${CDN_URL}/projects-media/project-05/thumbnail-1-sm.webp`,
        xl: `${CDN_URL}/projects-media/project-05/thumbnail-1-xl.webp`,
      },
      thumbnail2: {
        lg: `${CDN_URL}/projects-media/project-05/thumbnail-2-lg.webp`,
        md: `${CDN_URL}/projects-media/project-05/thumbnail-2-md.webp`,
        original: `${CDN_URL}/projects-media/project-05/thumbnail-2-original.webp`,
        sm: `${CDN_URL}/projects-media/project-05/thumbnail-2-sm.webp`,
        xl: `${CDN_URL}/projects-media/project-05/thumbnail-2-xl.webp`,
      },
    },
    project06: {
      thumbnail1: {
        lg: `${CDN_URL}/projects-media/project-06/thumbnail-1-lg.webp`,
        md: `${CDN_URL}/projects-media/project-06/thumbnail-1-md.webp`,
        original: `${CDN_URL}/projects-media/project-06/thumbnail-1-original.webp`,
        sm: `${CDN_URL}/projects-media/project-06/thumbnail-1-sm.webp`,
        xl: `${CDN_URL}/projects-media/project-06/thumbnail-1-xl.webp`,
      },
      thumbnail2: {
        lg: `${CDN_URL}/projects-media/project-06/thumbnail-2-lg.webp`,
        md: `${CDN_URL}/projects-media/project-06/thumbnail-2-md.webp`,
        original: `${CDN_URL}/projects-media/project-06/thumbnail-2-original.webp`,
        sm: `${CDN_URL}/projects-media/project-06/thumbnail-2-sm.webp`,
        xl: `${CDN_URL}/projects-media/project-06/thumbnail-2-xl.webp`,
      },
    },
    project07: {
      thumbnail1: {
        lg: `${CDN_URL}/projects-media/project-07/thumbnail-1-lg.webp`,
        md: `${CDN_URL}/projects-media/project-07/thumbnail-1-md.webp`,
        original: `${CDN_URL}/projects-media/project-07/thumbnail-1-original.webp`,
        sm: `${CDN_URL}/projects-media/project-07/thumbnail-1-sm.webp`,
        xl: `${CDN_URL}/projects-media/project-07/thumbnail-1-xl.webp`,
      },
      thumbnail2: {
        lg: `${CDN_URL}/projects-media/project-07/thumbnail-2-lg.webp`,
        md: `${CDN_URL}/projects-media/project-07/thumbnail-2-md.webp`,
        original: `${CDN_URL}/projects-media/project-07/thumbnail-2-original.webp`,
        sm: `${CDN_URL}/projects-media/project-07/thumbnail-2-sm.webp`,
        xl: `${CDN_URL}/projects-media/project-07/thumbnail-2-xl.webp`,
      },
    },
  },
  recentProjectImageArray: {
    "1": `${CDN_URL}/recent-project-image-array/1.webp`,
    "2": `${CDN_URL}/recent-project-image-array/2.webp`,
    "3": `${CDN_URL}/recent-project-image-array/3.webp`,
    "4": `${CDN_URL}/recent-project-image-array/4.webp`,
    "5": `${CDN_URL}/recent-project-image-array/5.webp`,
  },
  servicesMedia: {
    chapekarImage: `${CDN_URL}/services-media/chapekar-image.webp`,
    chapekarVideo: `${CDN_URL}/services-media/chapekar-video.webm`,
    mahakumbhImage: `${CDN_URL}/services-media/mahakumbh-image.webp`,
    mahakumbhVideo: `${CDN_URL}/services-media/mahakumbh-video.webm`,
    mpImage: `${CDN_URL}/services-media/mp-image.webp`,
    mpVideo: `${CDN_URL}/services-media/mp-video.webm`,
    emamiImage: `${CDN_URL}/services-media/emami-image.webp`,
    emamiVideo: `${CDN_URL}/services-media/emami-video.webm`,
    supremeCourtImageOptimized: `${CDN_URL}/services-media/supreme-court-image-optimized.webp`,
    supremeCourtVideoOptimized: `${CDN_URL}/services-media/supreme-court-video-optimized.webm`,
    textBg1: `${CDN_URL}/services-media/text-bg-1.webp`,
    textBg2: `${CDN_URL}/services-media/text-bg-2.webp`,
    textBg3: `${CDN_URL}/services-media/text-bg-3.webp`,
  },
  webBg: {
    background: `${CDN_URL}/web-bg/hero_temp.avif`,
  },
  awards: {
    award1: `${CDN_URL}/awards/award1.webp`,
    award2: `${CDN_URL}/awards/award2.webp`,
    award3: `${CDN_URL}/awards/award3.webp`,
    award4: `${CDN_URL}/awards/award4.webp`,
    award5: `${CDN_URL}/awards/award5.webp`,
    award6: `${CDN_URL}/awards/award6.webp`,
  },
  aboutUs: {
    img1: `${CDN_URL}/about-us/img1.webp`,
    img1Text: `${CDN_URL}/about-us/img1-text.webp`,
    img2: `${CDN_URL}/about-us/img2.webp`,
    img2Text: `${CDN_URL}/about-us/img2-text.webp`,
    img3: `${CDN_URL}/about-us/img3.webp`,
    img3Text: `${CDN_URL}/about-us/img3-text.webp`,
  }
} as const;

// Types for easy usage and autocompletion
export type GalleryCarouselImage = keyof typeof cdnImages.galleryCarousel;
export type GalleryCarouselSize = keyof (typeof cdnImages.galleryCarousel)["1"];
export type HeroBgImage = keyof typeof cdnImages.heroBg;
export type LogoImage = keyof typeof cdnImages.logos;

export type ProjectsMediaProject = keyof typeof cdnImages.projectsMedia;
export type ProjectsMediaImage<P extends ProjectsMediaProject> =
  keyof (typeof cdnImages.projectsMedia)[P];
export type ProjectsMediaSize =
  keyof (typeof cdnImages.projectsMedia)["project01"]["thumbnail1"]; // Assuming "project01" and its "thumbnail1" are representative for sizes

export type RecentProjectImage = keyof typeof cdnImages.recentProjectImageArray;
export type ServicesMediaItem = keyof typeof cdnImages.servicesMedia;
